const translations = {
    'tooltip.biome': 'biom: %s',
    'tooltip.id': 'id: %s',
    'tooltip.qrs': 'q/r/s: %d/%d/%d',
    'tooltip.resources': 'zasoby: %s',
    'tooltip.resourcesHeader': 'zasoby:',
    'tooltip.unknown': 'nieznany region',
};

export default translations;
